import { type FilterChipsModalItem } from '@capsicum/common';
import styled from 'styled-components';

import { Chip } from '../../atoms/chip/Chip';

export type FilterChipsModalContentProps = {
	isItemSelected: (item: FilterChipsModalItem) => boolean;
	items?: Array<FilterChipsModalItem>;
	onItemSelect: (item: FilterChipsModalItem) => void;
	selectedTab: string;
	testID?: string;
};

export const FilterChipsModalContent = ({
	isItemSelected,
	items = [],
	onItemSelect,
	selectedTab,
	testID
}: FilterChipsModalContentProps) => {
	const renderItem = (item: FilterChipsModalItem) => {
		return (
			<S.StyledChip
				imageStart={item.icon}
				isSelected={isItemSelected(item)}
				key={item.id}
				style={{ marginRight: 12 }}
				testID={`${testID}-Chip-${item.id}`}
				text={item.label}
				value={item.id}
				variant="brand"
				onClick={() => onItemSelect({ ...item, tabName: selectedTab })}
			/>
		);
	};

	return (
		<S.Wrapper>
			{items?.map(item => {
				return renderItem(item);
			})}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
	`;
	export const StyledChip = styled(Chip)`
		margin-bottom: ${({ theme }) => `${theme.spacings.xsmall}`};
	`;
}
